var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"h6 mb-0 font-weight-bold font-alternate"},[_vm._v("\n    € "+_vm._s(_vm.$root.currencyDisplaySimple(_vm.price))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }